// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2UrCZ","logo":"Login_logo__k16nb"};